import { constants } from "../../../constants";
import { Avatar } from "./sections/AvatarSelection";
import { useEffect, useState } from "react";
import AvatarComponent from "../../common/avatar/avatar";
import Button from "@/components/ui/button";

type ImgProps = {
  spriteId: number;
  setSpriteId: (img: number) => void;
  curNames: Avatar[];
};
const ImgPicker = ({ spriteId, setSpriteId, curNames }: ImgProps) => {
  let back = constants.leftButton;
  let forward = constants.rightButton;

  const [idx, setIdx] = useState(0);

  useEffect(() => {
    let abc = curNames.findIndex((c) => c.id === spriteId);
    if (abc >= 0) {
      setIdx(abc);
    }
  }, [curNames, spriteId]);

  const [dogPet, setDogPet] = useState(false);

  useEffect(() => {
    let interval = setTimeout(() => {
      setDogPet(false);
    }, 1000);
    return () => clearInterval(interval);
  }, [dogPet]);

  function handleClick() {
    if (spriteId === 4) {
      setDogPet(true);
    }
  }

  function handleButton(n: number) {
    setIdx(n);
    setSpriteId(curNames[n].id);
  }

  // Handle keyboard arrow keys
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "ArrowLeft") {
      e.preventDefault();
      handleButton(
        (((idx - 1) % curNames.length) + curNames.length) % curNames.length
      );
    } else if (e.key === "ArrowRight") {
      e.preventDefault();
      handleButton((idx + 1) % curNames.length);
    }
  };

  return (
    <div
      className={"flex justify-center items-center gap-2 sm:gap-4 self-stretch"}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <Button
        size={"4xl"}
        className={
          "self-center leading-none text-4xl sm:text-7xl flex-shrink-0 min-w-[64px] min-h-[64px] sm:min-w-[88px] sm:min-h-[88px]"
        }
        type="button"
        onClick={() => {
          handleButton(
            (((idx - 1) % curNames.length) + curNames.length) % curNames.length
          );
        }}
        tabIndex={-1}
      >
        {back}
      </Button>

      <div
        className={"h-auto aspect-1 flex-shrink min-w-0 flex-grow"}
        onClick={handleClick}
        style={spriteId === 4 ? { cursor: "pointer" } : {}}
      >
        <AvatarComponent
          spriteId={spriteId}
          noAnimate
          special={dogPet}
          size="large"
          variant="profile"
        />
      </div>

      <Button
        size={"4xl"}
        className={
          "self-center leading-none text-4xl sm:text-7xl flex-shrink-0 min-w-[64px] min-h-[64px] sm:min-w-[88px] sm:min-h-[88px]"
        }
        type="button"
        onClick={() => {
          handleButton((idx + 1) % curNames.length);
        }}
        tabIndex={-1}
      >
        {forward}
      </Button>
    </div>
  );
};
export default ImgPicker;
